/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { queryToSearchString } from '~shared/helpers/query';
import { StandardsInformationKey } from '~shared/types/security';
import { OrgParamsOptional } from '../types/license';

export const LICENSE_ROUTE_NAME = 'license_profiles';
export const PROJECT_LICENSE_ROUTE_NAME = `project/${LICENSE_ROUTE_NAME}`;

const licenseBasePath = (params: OrgParamsOptional) => {
  return params.organization
    ? `/organizations/${params.organization}/${LICENSE_ROUTE_NAME}`
    : `/${LICENSE_ROUTE_NAME}`;
};

export function getLicenseProfilesUrl(params: OrgParamsOptional) {
  return {
    pathname: licenseBasePath(params),
  };
}

/**
 * SCA type findings are from OWASP Top 10 (2021 and 2017)
 * with distinct categories: a6 and a9.
 */
export function isScaTypeFinding(standardsInformationKey: string, findingCategory?: string) {
  return (
    (standardsInformationKey === StandardsInformationKey.OWASP_TOP10_2021 &&
      findingCategory === 'a6') ||
    (standardsInformationKey === StandardsInformationKey.OWASP_TOP10 && findingCategory === 'a9')
  );
}

export function getLicenseProfileShowUrl(params: { id: string } & OrgParamsOptional) {
  return {
    pathname: `${licenseBasePath(params)}/show`,
    search: queryToSearchString({
      id: params.id,
    }),
  };
}
